import { Checkbox } from 'react-bootstrap';
import React from 'react';
import TooltipElement from './tooltipElement';

const FilterTableHeader = ({
  total,
  isTotalFetching,
  isBackgroundRequestsEnabled,
  setIsBackgroundRequestsEnabled,
  onToggleIsBackgroundRequestsEnabled,
  clearFilters,
  clearSelection,
  isSelectable,
  isAnyItemSelected,
  isAnyFilterApplied,
  totalControls,
}) => {
  const getItems = () => {
    const items = [
      {
        onSelect: clearFilters,
        disabled: !isAnyFilterApplied,
        text: 'Clear filters',
      },
    ];

    if (!isSelectable) {
      return items;
    }

    return [
      ...items,
      {
        divider: true,
      },
      {
        onSelect: clearSelection,
        disabled: !isAnyItemSelected,
        text: 'Clear selection',
      },
    ];
  };

  const toggleIsBackgroundRequestsEnabled = () => {
    setIsBackgroundRequestsEnabled(!isBackgroundRequestsEnabled);

    if (onToggleIsBackgroundRequestsEnabled) {
      onToggleIsBackgroundRequestsEnabled(!isBackgroundRequestsEnabled);
    }
  };

  const BackgroundRequestsToggle = () => (
    <Checkbox
      className="mr-3"
      inline
      checked={isBackgroundRequestsEnabled}
      onChange={toggleIsBackgroundRequestsEnabled}
    >
      Background requests
    </Checkbox>
  );

  const Total = () => (
    <span className="mr-3">
      Total: {total}
    </span>
  );

  const TotalWithPlaceholder = () => (
    <span className="mr-3">
      Total: {isBackgroundRequestsEnabled ? (isTotalFetching ? 'loading...' : total) : 'n/a'}
    </span>
  );

  return (
    <div className="d-flex align-items-center justify-content-end filter-table-header">
      {totalControls ? <BackgroundRequestsToggle /> : ""}
      {totalControls && !total ? <TotalWithPlaceholder /> : <Total />}
      <TooltipElement
        type="dropdown"
        text="Clear..."
        disabled={false}
        icon="erase"
        id="create-licenses-select"
        bsSize="xsmall"
        className="btn btn-default"
        pullRight
        items={getItems()}
      />
    </div>
  );
};

export default FilterTableHeader;



// WEBPACK FOOTER //
// ./src/components/filterTableHeader.js